import { useQueryUpdate } from '@shared/hooks'
import { SegmentedProps } from 'antd'
import { Kanban, TextalignJustifycenter } from 'iconsax-react'
import queryString from 'query-string'
import { useLocation, useParams } from 'react-router-dom'

export const useLeadView = () => {
  const location = useLocation()
  const { params } = useQueryUpdate()
  const { id } = useParams()

  const urlParams = Object.keys(params).length
    ? `?${queryString.stringify(params)}`
    : ''

  const leadsListSegmentValue = id
    ? `/leads-list/${id}${urlParams}`
    : `/leads${urlParams}`

  const leadsKanbanSegmentValue = id
    ? `/leads-list/${id}/kanban${urlParams}`
    : `/leads/kanban${urlParams}`

  const segmentedValue = location.pathname.includes('/kanban')
    ? leadsKanbanSegmentValue
    : leadsListSegmentValue

  const segmentedOptions: SegmentedProps<string>['options'] = [
    {
      value: leadsListSegmentValue,
      label: <TextalignJustifycenter size={16} />
    },
    {
      value: leadsKanbanSegmentValue,
      label: <Kanban size={16} />
    }
  ]

  return {
    segmentedValue,
    segmentedOptions
  }
}
